
let $ = window.$
function exportarParaExcel (nomeRelatorio, conteudoHtml) {
  if (!$) $ = window.jQuery

  if ($ != null && $ !== undefined) {
    var data = $(conteudoHtml).find('table')[0]
    $('body').append('<div id="result" style="display:none"></div>')
    $('#result').append(data)
    $('#result').empty().append(data)
    $('#result table').table2excel({
      exclude: '.noExl',
      name: nomeRelatorio,
      filename: nomeRelatorio
    })

    $('#result').remove()
  }
}

export default {
  exportarParaExcel
}



// WEBPACK FOOTER //
// ./src/services/Relatorio.service.js